module.exports = __webpack_public_path__ + "static/media/sr-SP.67db4f39.md";